/* globals $, Highcharts, moment, WidgetDirective */
import icon from './exposure.png.js';
import { MW_VISUALIZATIONS_BASE_MODULE_NAME } from '@meltwater/mw-visualizations-angularjs';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

const ONE_HUNDRED_PERCENT = 100;

angular.module('MW.InsDashboard.volumeWidget', [
    'DashboardChartConfigService',
    'MW.Framework.TranslationService',
    'MW.Dashboard.DashboardWidgetService',
    'MW.InsDashboard.insightsBackendService',
    'MW.Framework.GeoService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.CoreCommon',
    'MW.InsDashboard.ChartService',
    'MW.InsDashboard.TransformSov',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.WidgetController',
    'MW.Configuration',
    'MW.Framework.CoreUserService',
    MW_VISUALIZATIONS_BASE_MODULE_NAME
]).directive('volumeWidget', [
    'DashboardChartConfigService',
    'translationService',
    'DashboardWidgetService',
    'insightsBackendService',
    '$filter',
    '$q',
    'GeoService',
    'InsWidgetConfigService',
    'CoreCommon',
    'ChartService',
    'TransformSov',
    'InsightsDataMaps',
    'CoreUserService',
    '$controller',
    function(DashboardChartConfigService, translationService,  DashboardWidgetService, insightsBackendService, $filter, $q, GeoService, InsWidgetConfigService, CoreCommon, ChartService, TransformSov, InsightsDataMaps, CoreUserService, $controller){
    var volumeWidget = DashboardWidgetService.getWidget('volume-widget');

    volumeWidget.editViewFile = 'graph_widget_view';
    volumeWidget.userViewFile = 'graph_widget_view';
    volumeWidget.maximizedViewFile = 'graph_widget_max';
    volumeWidget.reportViewFile = 'graph_widget_report';

    var volumeWidgetController = function($scope){
        $controller('WidgetController', {$scope: $scope});//inject the scope and use the basic widget controller
    };

    var volumeWidgetLink = function(scope) {
        var customData = {
            tooltip: {
                formatter: function() {
                    if(scope.widget.settings.dateComparison) {
                        if(this.points.length > 1) {
                            var deltaPercent = ((this.points[0].point.y - this.points[1].point.y) / this.points[1].point.y) * 100;
                        }
                        var s = '<div class="comparison-tooltip">';
                        $.each(this.points, function(i, point) {
                            s += '<div class="date"><b>' + $filter('mwConvertDateToUserTimezone')(point.point.date, 'fullDate')  + '</b></div>'
                            + '<div><div class="point" style="color:'+ point.point.series.color +'">\u25CF</div>'
                            + '<div class="volume">' + translationService.getLocalizedString('Count') + ' (#): ' + ': </div>'
                            + '<div class="volume"><b>' + Highcharts.numberFormat(point.point.y)
                            + '</b></div><div class="clearFix"></div></div>';
                        });
                        if(this.points.length > 1 && this.points[1].point.y > 0) {
                            s += '<div class="change">'
                             + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + Highcharts.numberFormat(deltaPercent) + '%'
                             + '</div>';
                        }
                        s += '</div>';
                        return s;
                    } else {
                        var searchName = (this.point.name) ? this.point.name : this.series.name;
                        var output = '<b>'+ searchName + '<br/>';
                        output += translationService.getLocalizedString('Count') + ' (#): ' + Highcharts.numberFormat(Math.abs(this.point.y), 0) + ' / ' + Highcharts.numberFormat(this.point.percent) + '%';
                        if(this.point.indx > 0){
                            //get previous percentage
                            var previousData = this.series.data[this.point.indx - 1].y;
                            if(previousData > 0) { // GYDA-4537 - Cannot calculate a change percentage if your previous value is 0
                                var greaterThanZeroDeltaPercent = ((this.point.y - previousData) / previousData) * ONE_HUNDRED_PERCENT;
                                output += '<br/>' + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + ' ' + Highcharts.numberFormat(greaterThanZeroDeltaPercent) +'%';
                            }
                        }
                        return output;
                    }
                }
            }
        };

        var chartOverrides = {
            max:customData
        };

        var settingsOverides = {
            fetchDataForPreviousRange: scope.widget.settings.dateComparison,
            yAxisTitle: 'Count'
        };

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var newParams = getRequestParams(newVal),
                breadcrumbString,
                breadcrumbArray,
                displayDate;

            if (newVal.indexOf('&drilled&') > -1) {
                if(newParams.date) {
                    displayDate = moment(newParams.date.split('T')[0]);
                    breadcrumbString = scope.breadcrumbs[scope.breadcrumbs.length - 1].name;
                    breadcrumbArray = breadcrumbString.split(',');
                    if (scope.dateBreakoutsMonth) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format('MMM') + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsQuarter) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', Q' + displayDate.quarter() + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsYear) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.year());
                    }
                }
            }
        });

        var getRequestParams = function getRequestParams(url) {
            var params = {};
            var searchStr = url.split('?')[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split('&');
                for(var key in paramsStr) {
                    params[paramsStr[key].split('=')[0]] = paramsStr[key].split('=')[1];
                }
            }
            return params;
        };

        var updateLastBreadcrumb = function updateLastBreadcrumb(lastBreadcrumb) {
            scope.breadcrumbs[scope.breadcrumbs.length - 1].name = lastBreadcrumb;
        };

        var chartConfiguration = {
            insightsService: 'statisticServiceDateHistogram',
            insightsObject : 'dateHistograms',
            charts:{
                spline:{ chart:ChartService.line,transform:TransformSov.spline, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides, customSettings:settingsOverides},
                donut:{ chart:ChartService.donut,transform:TransformSov.donut, dataMap:InsightsDataMaps.datamapDateVolume},
                column: {
                    chart: ChartService.column,
                    transform: TransformSov.column,
                    dataMap: InsightsDataMaps.datamapDateVolume,
                    custom: chartOverrides
                },
                areaspline: {chart: ChartService.area, transform: TransformSov.areaspline, dataMap: InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                table: {chart:{},transform:TransformSov.table,dataMap:InsightsDataMaps.datamapDateVolume}
            },
            table: {
                enabled: true,
                rowTitle: translationService.getLocalizedString('Date'),
                summaryTitle: translationService.getLocalizedString('Total'),
                titleField: 'name',
                countField: 'volume',
                percentField: 'sov',
                drilldown: function sovTableDrilldown(datapoint){
                    scope.internalDrillDown(datapoint.id,datapoint.date);
                },
                tooltip: function sovTableTooltip(datapoint){
                    return translationService.getLocalizedString('Volume: ') + datapoint.volume;
                },
                customRowTitleSort: true
            },
            mwVisualization: {
                column: {
                    chart: ChartService.mwGroupedColumn,
                    transform: TransformSov.mwGroupedColumn,
                    dataMap: {},
                    custom: {}
                }
            }
        };

        if (scope.widget.settings && scope.widget.settings.previousDateRange && scope.widget.settings.dateComparison) {
            chartConfiguration['previousDateStart'] = moment(scope.widget.settings.previousDateRange.startDate).tz(CoreUserService.getTimezone()).format();
            chartConfiguration['previousDateEnd'] = moment(scope.widget.settings.previousDateRange.endDate).tz(CoreUserService.getTimezone()).format();
        }

        if(chartConfiguration.mwVisualization) {
            scope.barChartSettings = {
                barChart: Object.assign({}, chartConfiguration.charts.column),
                groupedColumn: Object.assign({}, chartConfiguration.mwVisualization.column)
            };

            scope.mwVisualization = true;
        }
        scope.initWidget(chartConfiguration);
    };
    return new WidgetDirective(volumeWidget, volumeWidgetLink, volumeWidgetController);
}]).run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', function (DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Media Exposure'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Media Exposure widget provides insight into how media coverage ' +
            'for a brand, product, event or topic is trending over time. ' +
            'The widget can be used to benchmark up to 5 different inputs.'),
        directive: 'volume-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'maxAgents': 5
        },
        displayOrder: 1,
        allowExport: true,
        availableSettings: ['dateRange', 'title', 'news','social','broadcast','rss','tags', 'chartType', 'labelFormat', 'dateBreakouts', 'labelVisibility', 'dateComparison'],
        availableChartTypes:[{name:'Line',id:'spline'}, {name:'Bar',id:'column'}, {name: 'Donut', id:'donut'}, {name: 'Area', id: 'areaspline'}],
        requiredSettings: ['dateRange'],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length > 1) {
                return this.availableChartTypes[1];
            } else {
                return this.availableChartTypes[0];
            }
        },
        hasRequiredSettings: function(){
            var _widget = this;

            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
